import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';

export const MessageListContentsSkeleton = (): JSX.Element => {
  return (
    <>
      {[...Array(8)].map((_, idx) => {
        return (
          <Box key={idx} css={{ width: '100%' }}>
            <Bone type="chatBubble" css={{ width: '50%', marginBlock: 'tighter' }} />
            <Bone type="chatBubble" css={{ width: '58.33%', marginBlock: 'tighter' }} />
            <Box css={{ display: 'flex', justifyContent: 'flex-end', marginBlock: 'tighter' }}>
              <Bone type="chatBubble" css={{ width: '350px' }} />
            </Box>
            <Bone type="chatBubble" css={{ width: '75%', marginBlock: 'tighter' }} />
          </Box>
        );
      })}
    </>
  );
};
